/**
 * 将浏览器 device_key 同步到购物车 attributes，结账后进入订单 note_attributes（webhook 可读）
 */
(function () {
  const STORAGE_KEY = 'DEVICE_ID';
  const CART_ATTRIBUTE_NAME = 'device_key';

  function getDeviceKey() {
    try {
      let id = localStorage.getItem(STORAGE_KEY);
      if (id && id.length >= 8) return id;
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        id = crypto.randomUUID();
      } else {
        id = 'dk-' + Date.now() + '-' + Math.random().toString(16).slice(2);
      }
      localStorage.setItem(STORAGE_KEY, id);
      return id;
    } catch (e) {
      return 'dk-' + Date.now();
    }
  }

  let syncPromise = null;

  function syncDeviceKeyToCart() {
    if (syncPromise) return syncPromise;

    const deviceKey = getDeviceKey();
    const updateUrl = window.routes?.cart_update_url || '/cart/update.js';

    syncPromise = fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [CART_ATTRIBUTE_NAME]: deviceKey
        }
      })
    })
      .catch(function () {})
      .finally(function () {
        syncPromise = null;
      });

    return syncPromise;
  }

  function bindCheckoutSync() {
    document.addEventListener(
      'click',
      function (event) {
        const link = event.target.closest('a[href*="/checkout"]');
        if (link) syncDeviceKeyToCart();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;
        if (form?.action && String(form.action).indexOf('/checkout') !== -1) {
          syncDeviceKeyToCart();
        }
      },
      true
    );
  }

  function init() {
    syncDeviceKeyToCart();
    bindCheckoutSync();

    document.addEventListener('cart:updated', syncDeviceKeyToCart);

    if (typeof subscribe === 'function') {
      subscribe('cart-update', syncDeviceKeyToCart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MonsseasDeviceKey = {
    get: getDeviceKey,
    sync: syncDeviceKeyToCart,
    attributeName: CART_ATTRIBUTE_NAME
  };
})();
